import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-wrap footer-grid">
        <div>
          <strong>Huntington Beach Concours</strong>
          <p>
            P.O. Box 5578
            <br />
            Huntington Beach, CA 92615-5578
          </p>
        </div>
        <div>
          <p>
            Huntington Beach Library
            <br />
            7111 Talbert Ave.
            <br />
            Huntington Beach, CA 92648
          </p>
        </div>
        <nav>
          <Link to="/show">The Show</Link>
          <Link to="/tickets">Spectator tickets</Link>
          <Link to="/luncheon">Luncheon</Link>
          <Link to="/awards">Awards</Link>
          <Link to="/awards?section=entry">Rules</Link>
          <Link to="/company-information">Company</Link>
          <Link to="/login">Sign in</Link>
        </nav>
      </div>
      <p className="footer-copy">© {new Date().getFullYear()} HB Concours d'Elegance</p>
    </footer>
  );
}

export default Footer;
